import React from 'react';
import { Link, navigate } from 'gatsby';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Search } from '@styled-icons/material-outlined';

import HeroButton from 'components/HeroButton/heroButton';

const StyledWrapper = styled.nav`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${({ theme }) => theme.color.first};
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '-100%')});
  transition: transform 0.3s ease-in-out;
  z-index: 9990;
  ${({ theme }) => theme.mq.desktop} {
    display: none;
  }
`;

const MenuLinksWrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

const MenuLink = styled.li`
  margin: 15px 0;
  list-style: none;
  font-size: ${({ theme }) => theme.font.size.m};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-display: swap;
  text-transform: uppercase;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  transition: opacity 0.4s 0.3s ease-in-out;
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.color.second};
  }
`;

const SearchButton = styled(HeroButton)`
  opacity: 1;
  width: 160px;
  height: 46px;
  background: ${({ theme }) => theme.color.second};
  border: 2px solid ${({ theme }) => theme.color.second};
  padding: 0;
  margin: 20px 10px 0 0;
  &:hover {
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const StyledSearch = styled(Search)`
  margin-left: 10px;
`;

const menuItems = [
  { name: 'Home', href: 'home' },
  { name: 'inwestycje', href: 'inwestycje' },
  { name: 'o nas', href: 'o_nas' },
  { name: 'oferta', href: 'oferta' },
  { name: 'kontakt', href: 'kontakt' },
];

const MobileMenu = ({ isOpen, closeMenu }) => (
  <StyledWrapper isOpen={isOpen}>
    <MenuLinksWrapper>
      {menuItems.map(item => (
        <MenuLink onClick={closeMenu} isOpen={isOpen} key={item.name}>
          <StyledLink aria-label="przycisk menu" to={`/#${item.href}`}>
            {item.name}
          </StyledLink>
        </MenuLink>
      ))}
      <MenuLink onClick={closeMenu} isOpen={isOpen}>
        <SearchButton id="szukaj" onClick={() => navigate('/#search')}>
          szukaj
          <StyledSearch size="25" title="Search" />
        </SearchButton>
      </MenuLink>
    </MenuLinksWrapper>
  </StyledWrapper>
);

MobileMenu.defaultProps = {
  isOpen: false,
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  closeMenu: PropTypes.func.isRequired,
};

export default MobileMenu;
